<template>
  <div class="hello">

    <div class="Joinbanner">
  
      <div class="MethodsBanner">
  
        <img src="../assets/exampleWord.png" class="exampleWordPic">
  
      </div>
  
      <div class="com-center-title">
  
        <h4>最新案例</h4>
  
      </div>
  
      <div class="product">
  
        <div class="example">
  
          <div class="exampleTop">
  
            <img src="../assets/x.png" class="example1Pic">
  
            <div class="example1Word">
  
              <h4  @click="dialogVisible = true"><a href="#example">吉林省游戏游艺设备认证系统</a></h4>
  
              <p>面积1700平方，辐射周边人口20万人。主要问题：新开业，希望快速发展用户。客户对接好酷酷宝系统后，首先发挥开业期间都是爆满的。总结：酷酷宝的自bb ...</p><span>2016-11-17</span></div>
  
          </div>
  
          <div class="exampleBottom">
  
            <ul>
  
              <li><a href="#example">吉林省游戏游艺设备认证系统解决方案啦啦...</a><span class="date">2016-11-17</span></li>
  
              <li><a href="#example">吉林省游戏游艺设备认证系统解决方案啦啦...</a><span class="date">2016-11-17</span></li>
  
            </ul>
  
          </div>
  
        </div>

        <div class="example">
  
          <div class="exampleTop">
  
            <img src="../assets/x.jpg" class="example1Pic">
  
            <div class="example1Word">
  
              <h4  @click="dialogVisible = true"><a href="#example">吉林省游戏游艺设备认证系统</a></h4>
  
              <p>面积1700平方，辐射周边人口20万人。主要问题：新开业，希望快速发展用户。客户对接好酷酷宝系统后，首先发挥开业期间都是爆满的。总结：酷酷宝的自bb ...</p><span>2016-11-17</span></div>
  
          </div>
  
          <div class="exampleBottom">
  
            <ul>
  
              <li><a href="#example">吉林省游戏游艺设备认证系统解决方案啦啦...</a><span class="date">2016-11-17</span></li>
  
              <li><a href="#example">吉林省游戏游艺设备认证系统解决方案啦啦...</a><span class="date">2016-11-17</span></li>
  
            </ul>
  
          </div>
  
        </div>
  
      </div>
  
    </div>

    <el-dialog

      title="案例详情"

      :visible.sync="dialogVisible"

      size="small">

      <img src="../assets/p23.jpg">

      <h3>吉林省游戏游艺设备认证系统解决方案</h3>

    </el-dialog>
  
  </div>
</template>

<script>

  export default {
  
    name: 'hello',

    data() {
  
      return {
  
        dialogVisible: false,

      }
  
    },
  
  
    methods: {
  
    }
  
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped media="all" type="text/css">
  @import url("../css/comm.css");
  
  .MethodsBanner {
    width: 100%;
    position: relative;
    background: url('../assets/examplee.png') no-repeat;
    background-size: cover;
    display: flex;
    justify-content: center;
}

.exampleWordPic {
    padding: 3rem 0;
}

.MethodsPic {
    width: 100%;
    height: auto;
}

.product {
    display: flex;
    position: relative;
    justify-content: center;
    padding-bottom: 5rem;
}

.example {
    width: 25rem;
    padding-right: 2rem;
}

.exampleTop {
    border-bottom: 1px solid #cccccc;
    display: flex;
    padding-bottom: 1rem;
}

.exampleTop img {
    width: 160px;
    height: 160px;
    margin-right: 20px;
}

.example1Word h4 {
    font-size: 14px;
    line-height: 14px;
    letter-spacing: 0.4px;
    text-align: left;
    color: #333333;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.example1Word p {
    font-size: 12px;
    line-height: 1.33;
    letter-spacing: 0.6px;
    text-align: justify;
    color: #999999;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
}

.example1Word span {
    font-family: FZLTXHK-GBK1-0;
    font-size: 12px;
    line-height: 1.33;
    text-align: left;
    color: #999999;
}

.exampleBottom {}

.exampleBottom ul {
    margin-top: 14px;
    list-style-type: disc;
}

.exampleBottom ul li {
    font-size: 12px;
    line-height: 13px;
    letter-spacing: 0.3px;
    text-align: left;
    color: #333333;
    margin-bottom: 11px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.date {
    width: 70px;
    font-family: FZLTXHK-GBK1-0;
    font-size: 10px;
    line-height: px;
    text-align: right;
    color: #999999;
}

.exampleBottom ul li a {
    width: 246px;
    overflow: hidden;
    display: inline-block;
    height: 13px;
}

a:link {
    text-decoration: none;
    color: #333333;
    overflow: hidden;
}

a:visited {
    text-decoration: none;
    color: #333333;
}

a:hover {
    text-decoration: none;
    color: #00aeef;
}

a:active {
    text-decoration: none;
    color: #333333;
}

.el-dialog__headerbtn {
    float: right;
    background: 0 0;
    border: none;
    outline: 0;
    padding: 0;
    cursor: pointer;
    /* right: 0; */
    position: relative;
    left: 0;
    width: 80px;
}

.el-dialog__header {
    width: auto;
    height: auto;
}

.el-dialog--tiny {
    width: 948px;
}

.modalPic {
    width: 833px;
    height: auto;
}

.el-dialog__headerbtn .el-dialog__close {
    color: #000000;
    width: 20px;
    height: 50px;
    font-size: 20px;
}

.el-dialog__headerbtn[data-v-bbbaf6fe] {
    float: right;
    background: 0 0;
    border: none;
    outline: 0;
    padding: 0;
    cursor: pointer;
    /* right: 0; */
    position: relative;
    left: 0;
    width: 15px;
    height: 40px;
    line-height: 40px;
}

.ModallTiTle {
    width: 833px;
    position: relative;
    height: 32px;
    top: 25px;
    margin: 0 auto
}

.ModallTiTle p {
    width: 590px;
    height: 32px;
    font-family: FZLTZHK-GBK1-0;
    font-size: 26px;
    line-height: 32px;
    letter-spacing: 0.7px;
    text-align: left;
    color: #333333;
    display: inline-block;
    position: absolute;
    left: 0;
}

.ModallTiTle img {
    width: 144px;
    height: 32px;
    position: absolute;
    display: inline-block;
    right: 0
}

.ModalDate {
    width: 833px;
    height: 12px;
    position: relative;
    margin: 0 auto;
    top: 46px;
}

.ModalDate p {
    width: 88px;
    height: 12px;
    font-family: FZLTZHK-GBK1-0;
    font-size: 14px;
    line-height: 12px;
    letter-spacing: 0.4px;
    text-align: left;
    color: #666666;
    display: inline-block;
    position: absolute;
    left: 0;
}

.el-dialog__body {
    padding: 30px 20px;
    color: #48576a;
    font-size: 14px;
    height: 1300px;
}

.swiper-container {
    width: 834px;
    height: 300px;
    font-family: FZLTXHK-GBK1-0;
    font-size: 14px;
    line-height: 1.43;
    letter-spacing: 0.4px;
    text-align: left;
    color: #333333;
    position: relative;
    top: 78px;
    margin: 0 auto
}

.swiper-slide p {
    font-family: FZLTXHK-GBK1-0;
    font-size: 14px;
    line-height: 1.43;
    letter-spacing: 0.4px;
    text-align: left;
    color: #333333;
}

.swiper-slide {
    font-size: 18px;
    height: auto;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding-right: 15px;
}

.onMouseActive {
    color: #42a4fc
}
   
</style>



// WEBPACK FOOTER //
// example.vue?27d1763a